// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__NyFrI","selects":"Documents_selects__EN7mT"};